import PageMeta from "components/components/Meta/PageMeta";
import AdditionalInfoSection from "components/dataVisualization/dataPageComponents/AdditionalInfoSection/AdditionalInfoSection";
import PageHeader from "components/dataVisualization/dataPageComponents/PageHeader/PageHeader";
import RestorationZoneDemandForecastContainer from "components/dataVisualization/restorationZone/DemandForecast/RestorationZoneDemandForecastContainer/RestorationZoneDemandForecastContainer";
import { Region } from "components/dataVisualization/restorationZone/RegionFilter";
import React from "react";

const RestorationZoneDemandForecast: React.FC = () => (
  <>
    <PageMeta title="Restoration region demand forecast" />
    <PageHeader
      title="Restoration region demand forecast"
      pageDescription={
        <>
          <p>
            Each day at 09:00, 11:45 and 17:00 London time, National Energy
            System Operator (NESO) creates a forecast peak value for the
            day-ahead demand effective for the Settlement date and Restoration
            region. For GMT periods, the 60% and 100% is currently based on the
            preceding winter demand peak. For BST periods, the 60% and 100% is
            based on the preceding summer demand minimum.
          </p>
          <p>
            For regions where generation is greater than the local demand,
            forecast values are truncated to zero.
          </p>
          <p>
            At a later date, NESO will use monthly and daily snapshots to
            dynamically derive the values.
          </p>
        </>
      }
      expanderHeading="What you need to know while using this data"
      expanderContent={
        <>
          <p>
            There are 7 regions, these are used to plan and monitor the
            restoration of power in the event of a major outage.
          </p>
          <ul>
            <li>{Region.SouthEast}</li>
            <li>{Region.SouthWest}</li>
            <li>{Region.Midlands}</li>
            <li>{Region.NorthEast}</li>
            <li>{Region.NorthWest}</li>
            <li>{Region.NorthScotland}</li>
            <li>{Region.SouthScotland}</li>
          </ul>
          <p>
            The published values for each restoration region are based on
            segments of National Demand and exclude demand supplied by embedded
            generation which do not provide operational metering data to NESO;
            as a result the underlying demand will be higher.
          </p>
          <p>Note: GSP Group ID will be included when provided by NESO.</p>
        </>
      }
    />
    <RestorationZoneDemandForecastContainer />
    <AdditionalInfoSection
      documentationInformation={{
        chart: ["datasets/RZDF"],
      }}
    />
  </>
);

export default RestorationZoneDemandForecast;
